module.exports = __webpack_public_path__ + "static/media/Gridnew.9df4c8a0.svg";